var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHelp = function SvgIconHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10.6 15.8v.042M8.201 8.045c0-1.35 1.075-2.445 2.4-2.445 1.326 0 2.4 1.095 2.4 2.445s-1.074 2.446-2.4 2.446l-.001 1.63M20.2 5v12a3.6 3.6 0 0 1-3.6 3.6h-12A3.6 3.6 0 0 1 1 17V5a3.6 3.6 0 0 1 3.6-3.6h12A3.6 3.6 0 0 1 20.2 5"
  })));
};
export default SvgIconHelp;